module.exports = __webpack_public_path__ + "img/img14.504bc782.png";